import router from '@/router';
import { routes } from '../config';

routes.forEach(route => router.addRoute(route));
